import { FormFieldIconButton } from "@faire/slate/private/form/FormFieldIconButton";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Close as CloseIcon } from "@faire/web/slate/icons/foundation/Close";
import React from "react";

interface IProps {
  label?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const ClearButton: React.FC<IProps> = ({ label, onClick }) => {
  const { strictLocalize } = useStrictLocalization();
  return (
    <FormFieldIconButton
      Icon={CloseIcon}
      onClick={onClick}
      aria-label={
        label ??
        strictLocalize({
          id: "3JICzw",
          defaultMessage: "Clear search",
          description: {
            text: "Label for button to clear the search input",
          },
        })
      }
    />
  );
};
